module.exports = __webpack_public_path__ + "img/martelo.9ea8aed3.svg";